export const NumberFormat = (value, region = "en-IN") => {
    return Intl.NumberFormat(region).format(value);
}

export const CurrencyFormat = (value, region = "en-IN", currencyType) => {
    // TODO: will optimize later stage later
    return Intl.NumberFormat(region, { style: "currency", currency: currencyType}).format(value)
}